export const UserQueryKeys = {
  UserById: 'user-by-id',
  UserByIdentityGuid: 'user-by-identity-guid',
}
